import SearchIcon from '@mui/icons-material/Search'
import { Box, InputAdornment, TextField, Tooltip } from '@mui/material'
import type React from 'react'
import { useContext, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { LanguageContext } from '../util/LanguageContext'

type SearchFieldProps = {
  onKeyDown: (deviceId: string) => void
}
export const SearchField: React.FC<SearchFieldProps> = props => {
  const auth = useAuth()
  const [text, setText] = useState('')
  const translation = useContext(LanguageContext)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setText(event.target.value)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      // エンターキーが押されたとき
      props.onKeyDown(text)
    }
  }
  const handleSearchClick = () => {
    props.onKeyDown(text)
  }

  return (
    <>
      <Tooltip title={translation['search_by_id']} placement="top-start" enterTouchDelay={0}>
        <TextField
          disabled={auth.isDisable}
          placeholder={translation['search']}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                  onClick={handleSearchClick}
                  style={{ cursor: 'pointer' }}
                >
                  <SearchIcon />
                </Box>
              </InputAdornment>
            ),
          }}
          sx={{
            height: '54px',
            width: '400px',
            '@media (max-width: 1600px)': {
              width: '250px',
            },
            background: '#FFFFFF',
            boxShadow: '0px 2px 2px #00000014',
            borderRadius: '40px',
            '& .MuiOutlinedInput-root': {
              border: 'none',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
        />
      </Tooltip>
    </>
  )
}
